import { useId, type ComponentProps } from 'react'
import { useWindowDimensions } from 'react-native'
import Svg, { Defs, Pattern, Path, Rect } from 'react-native-svg'
import { useMediaQuery } from 'react-responsive'
import { mesaColorNames } from '@/src/common/theme'

export function MesaMonogram(props: ComponentProps<typeof Svg> & { mode?: 'light' | 'dark' }) {
  const mesaMonogramPatternId = useId()
  const { width: windowWidth } = useWindowDimensions()
  const width = windowWidth * (useMediaQuery({ minWidth: 720 }) ? 1.5 : 2)
  const height = width

  return (
    <Svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid slice"
      {...props}
    >
      <Defs>
        <Pattern
          id={mesaMonogramPatternId}
          viewBox="0,0,100,136"
          width={100}
          height={136}
          patternUnits="userSpaceOnUse"
        >
          <Path
            fill={
              props.mode === 'light'
                ? mesaColorNames['Mesa - Brand/White #FFFFFF']
                : mesaColorNames['Mesa - Brand/Secondary #223843']
            }
            d="M0 0H100V136H0z"
          />
          <Path
            opacity={0.04}
            d="M55.382 76H71.03a4.378 4.378 0 014.381 4.389V94.73l10.406-6.192a3.034 3.034 0 013.052 0l10.406 6.192V80.389A4.378 4.378 0 01103.656 76h15.648a4.378 4.378 0 014.382 4.389v35.267c0 1.645-.939 3.213-2.504 3.996L89.26 135.17c-1.252.627-2.66.627-3.834 0l-31.922-15.518c-1.487-.705-2.504-2.272-2.504-3.996V80.389A4.378 4.378 0 0155.382 76zm14.083 5.878H56.79v32.915l30.435 14.812 30.436-14.812V81.878h-12.675v18.025a2.931 2.931 0 01-1.487 2.586 2.89 2.89 0 01-2.973 0l-13.3-7.993-13.302 7.993a2.89 2.89 0 01-2.973 0 2.93 2.93 0 01-1.486-2.586V81.878zM-44.618 75.622h15.648a4.378 4.378 0 014.381 4.389v14.341l10.406-6.19a3.034 3.034 0 013.051 0l10.407 6.19V80.011a4.378 4.378 0 014.381-4.39h15.648a4.378 4.378 0 014.382 4.39v35.266c0 1.646-.94 3.214-2.504 3.997l-31.922 15.518c-1.252.627-2.66.627-3.834 0l-31.922-15.518c-1.487-.705-2.504-2.273-2.504-3.997V80.011a4.378 4.378 0 014.382-4.39zm14.083 5.878H-43.21v32.915l30.435 14.812 30.436-14.812V81.5H4.986v18.025a2.932 2.932 0 01-1.487 2.586 2.89 2.89 0 01-2.973 0l-13.3-7.994-13.302 7.994a2.89 2.89 0 01-2.973 0 2.932 2.932 0 01-1.486-2.586V81.5zM68.308 59.644H52.66a4.378 4.378 0 01-4.381-4.39V40.913L37.87 47.104a3.035 3.035 0 01-3.052 0l-10.406-6.192v14.343c0 2.43-1.957 4.39-4.382 4.39H4.38A4.378 4.378 0 010 55.254v-35.27c0-1.645.939-3.213 2.504-3.996L34.428.47c1.252-.627 2.66-.627 3.834 0L70.186 15.99c1.487.705 2.504 2.273 2.504 3.997v35.269c0 2.43-1.956 4.39-4.382 4.39zm-14.162-5.878h12.676V20.848L36.384 6.035 5.947 20.848v32.918h12.675V35.739c0-1.097.548-2.037 1.487-2.586a2.892 2.892 0 012.973 0l13.302 7.994 13.302-7.994a2.892 2.892 0 012.973 0 2.932 2.932 0 011.487 2.586v18.027z"
            fill="#42BDAA"
          />
        </Pattern>
      </Defs>
      <Rect fill={`url(#${mesaMonogramPatternId})`} width={width} height={height} />
    </Svg>
  )
}
